<template>
  <div class="block">
    <div
      v-for="fav in tags.slice(0, max)" :key="fav.Tag" class="float-right rounded-full mr-0.5 w-2 h-2"
      :style="{ backgroundColor: fav.Color }"
    />
  </div>
</template>

<script lang="ts" setup>
import type SimpleFavoriteTag from '@/models/simpleFavoriteTag'

defineProps<{
  tags: SimpleFavoriteTag[]
  max: number
}>()
</script>
